import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class OwnerService {
  private api = inject(ApiService);

  list(scope: string | 'all' = 'all') {
    const path = scope === 'all' ? '/owner' : `/owner/${scope}`;
    return this.api.get(path);
  }
  upsert(json: any) { return this.api.post('/owner', json); }
  remove(id: number) { return this.api.get(`/owner/remove/${id}`); }
}
